class HHAnimateDetailsWrapper extends HTMLElement {
  constructor() {
    super()
    this.animation = null
    this.isClosing = false
    this.isExpanding = false
  }

  connectedCallback() {
    this.details = this.querySelector('details')
    this.summary = this.querySelector('summary')
    this.content = this.querySelector(this.getAttribute('content-selector'))
    this.backButton = this.querySelector('[data-mobile-menu-back-button]')

    this.summary.addEventListener('click', this.onClick.bind(this))
    this.backButton.addEventListener('click', this.onClick.bind(this))
  }

  disconnectedCallback() {
    this.summary.removeEventListener('click', this.onClick)
    this.backButton.removeEventListener('click', this.onClick)
  }

  onClick(e) {
    e.preventDefault()
    if (this.isClosing || !this.details.open) {
      this.open()
    } else if (this.isExpanding || this.details.open) {
      this.close()
    }
  }

  open() {
    this.details.open = true

    window.requestAnimationFrame(() => {
      this.expand()
    })
  }

  expand() {
    this.isExpanding = true
    if (this.animation) this.animation.cancel()

    this.animation = this.content.animate(
      {
        transform: ['translateX(100%)', 'translateX(0)'],
      },
      {
        fill: 'forwards',
        duration: 400,
        easing: 'ease-out',
      }
    )

    this.animation.onfinish = () => this.onAnimationFinish(true)
    this.animation.oncancel = () => (this.expanding = false)
  }

  close() {
    this.isClosing = true
    if (this.animation) this.animation.cancel()

    this.animation = this.content.animate(
      {
        transform: ['translateX(0)', 'translateX(100%)'],
      },
      {
        fill: 'forwards',
        duration: 400,
        easing: 'ease-in',
      }
    )

    this.animation.onfinish = () => this.onAnimationFinish(false)
    this.animation.oncancel = () => (this.isClosing = false)
  }

  onAnimationFinish(open) {
    this.details.open = open
    this.animation = null
    this.isClosing = false
    this.isExpanding = false
  }
}

customElements.define('hh-animate-details-wrapper', HHAnimateDetailsWrapper)
